var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PerfectScrollbar',{ref:"list",staticClass:"assign-list pr-1",class:_vm.aClass},[_vm._t("AssignItem")],2)}
var staticRenderFns = []

export { render, staticRenderFns }